/** 组卷：已用分、剩余分、题库题目是否已在试卷中 */

export function paperScoreLimit(paperInfo) {
  const total = Number(paperInfo && paperInfo.paperTotalScore)
  return Number.isFinite(total) && total > 0 ? total : 0
}

export function paperUsedScore(paperInfo) {
  const list = (paperInfo && paperInfo.questionList) || []
  return list.reduce((sum, item) => sum + (Number(item && item.score) || 0), 0)
}

export function rulesPlannedScore(rules) {
  return (rules || []).reduce((sum, rule) => {
    const num = Number(rule && rule.questionNum) || 0
    const score = Number(rule && rule.score) || 0
    return sum + num * score
  }, 0)
}

/** 自定义生成或模版当前规则将占用的分数；规则未填完时为 0 */
export function createFormPlannedScore(form, templates) {
  if (!form || form.createType === '搜索添加') return 0
  let rules = []
  if (form.createType === '自定义生成') {
    rules = form.questionRules || []
  } else if (form.createType === '按模版生成') {
    const uid = form.createRules
    if (!uid) return 0
    const list = templates || []
    const tpl = list.find((item) => item && (item.uid === uid || item.value === uid))
    if (!tpl) return 0
    rules = tpl.questionRules || []
  }
  return rulesPlannedScore(rules)
}

export function createFormOverflow(paperInfo, form, templates) {
  const planned = createFormPlannedScore(form, templates)
  if (!planned) return ''
  return scoreOverflowMessage(paperInfo, planned)
}

/** 超出建卷总分时返回提示，否则空串 */
export function scoreOverflowMessage(paperInfo, addScore) {
  const limit = paperScoreLimit(paperInfo)
  if (!limit) return ''
  const used = paperUsedScore(paperInfo)
  const add = Number(addScore) || 0
  if (used + add <= limit + 0.001) return ''
  const remain = Math.max(0, Math.round((limit - used) * 100) / 100)
  return (
    '试卷总分 ' +
    limit +
    ' 分，已有试题 ' +
    used +
    ' 分，还可添加 ' +
    remain +
    ' 分。本次将新增 ' +
    add +
    ' 分，会超过试卷总分，请减少题量或分值。'
  )
}

function plainContent(text) {
  return String(text || '')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, '')
}

export function paperAddedKeys(paperInfo) {
  const keys = {}
  ;((paperInfo && paperInfo.questionList) || []).forEach((item) => {
    if (!item) return
    const uid = String(
      item.questionBankUid ||
        item.quetionBankUid ||
        item.question_bank_uid ||
        ''
    ).trim()
    if (uid) keys[uid] = true
    const content = plainContent(item.content || item.questionContent)
    if (content) keys['c:' + content] = true
  })
  return keys
}

export function isQuestionOnPaper(item, keys) {
  if (!item || !keys) return false
  const uid = String(item.uid || item.questionBankUid || '').trim()
  if (uid && keys[uid]) return true
  const content = plainContent(item.content || item.questionContent)
  return !!(content && keys['c:' + content])
}
